import { ELITE_TYC_MARCA } from "services/tycElite.service";

const META_REGEX = /^<!--\s*ev-tyc:([\s\S]*?)\s*-->/;

const parseTycMeta = (texto = "") => {
  const match = texto.match(META_REGEX);

  if (!match) {
    return {
      texto,
      activo: true,
      refId: null,
      marca: null,
    };
  }

  try {
    const meta = JSON.parse(match[1]);
    return {
      texto: texto.replace(META_REGEX, "").trim(),
      activo: meta.activo !== false,
      refId: meta.refId || null,
      marca: meta.marca || null,
    };
  } catch {
    return {
      texto: texto.replace(META_REGEX, "").trim(),
      activo: true,
      refId: null,
      marca: null,
    };
  }
};

const buildTycTextoWithMeta = (texto, { activo = true, refId, marca = ELITE_TYC_MARCA }) => {
  const meta = JSON.stringify({
    activo,
    refId,
    marca,
  });

  return `<!-- ev-tyc:${meta} -->${texto}`;
};

const isEliteTycRecord = (record) => {
  const parsed = parseTycMeta(record.texto || "");

  if (parsed.marca === ELITE_TYC_MARCA) {
    return true;
  }

  const plain = `${record.titulo || ""} ${parsed.texto || ""}`.toLowerCase();
  return (
    plain.includes("elite vacances") &&
    !plain.includes("grupo alianza colombia")
  );
};

const normalizeTycElite = (record) => {
  const parsed = parseTycMeta(record.texto || "");

  return {
    apiId: record.id,
    id: parsed.refId || `promo-${record.id}`,
    titulo: record.titulo || "",
    texto: parsed.texto,
    activo: parsed.activo,
  };
};

const filterEliteTycRecords = (records = []) =>
  records.filter(isEliteTycRecord).map(normalizeTycElite);

const filterActiveTycElite = (promos = []) =>
  promos.filter((promo) => promo.activo !== false);

const buildTycElitePayload = (promo) => {
  const titulo = promo.titulo?.trim();
  const texto = promo.texto?.trim();

  if (!titulo) {
    throw new Error("El título de la promoción es obligatorio.");
  }

  if (!texto) {
    throw new Error("El texto de términos y condiciones es obligatorio.");
  }

  return {
    titulo,
    texto: buildTycTextoWithMeta(texto, {
      activo: promo.activo !== false,
      refId: promo.id,
      marca: ELITE_TYC_MARCA,
    }),
  };
};

const getTycEliteErrorMessage = (error, fallback) => {
  const data = error?.response?.data;

  if (typeof data === "string" && data.trim()) {
    return data.trim();
  }

  if (data?.message) {
    return data.message;
  }

  if (error?.message) {
    return error.message;
  }

  return fallback;
};

export {
  parseTycMeta,
  buildTycTextoWithMeta,
  normalizeTycElite,
  filterEliteTycRecords,
  filterActiveTycElite,
  buildTycElitePayload,
  getTycEliteErrorMessage,
};
